import React from "react";
import RuteadorContent from "../pages/RuteadorPage/RuteadorContent";
import * as ACTIONS from "../store/actions/actions";
import { connect } from "react-redux";
import ModalLay from "./ModalLay/ModalLay";
import { Crud_Catalogos, Crud_error } from "../herramientas/Crud_Catalogos";
import { safeJsonParse } from "../herramientas/JsonSafe";
import {
  Form,
  Grid,
  Card,
  Alert,
  Icon,
  Dimmer,
  Button,
} from "tabler-react";
import { TablePageable } from "../Helpers";
import { ImportarN,ImportarNJson, Exportar, Plantilla, Manual } from "../herramientas/Excel";
import Select from "react-select";
import { NotificationManager} from 'react-notifications';
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import MonitoreoMensajeria from "../socket/MonitoreoMensajeria";
import EtaCalculada from "../Monitoristas/Monitoreo/panelForms/EtaCalculada";
import IncompletosTerminados from "./IncompletosTerminados";
import { timeToMilisegundos, timeToDateFill } from "../herramientas/DateFormat";
import classes from "./Especifico.module.css";
import { validarHorarios, validarEstadiaCorta } from './navieras/validaciones';
import { publicarLlamadaWebphone } from "../socket/publicarLlamadaWebphone";
var user = JSON.parse(sessionStorage.getItem("usuario"));
var currentUser = JSON.parse(sessionStorage.getItem("currentUser"));




let movsArray = {};
let avisosEstatusNav= localStorage.getItem("avisosEstatusNav")? {...JSON.parse(localStorage.getItem("avisosEstatusNav"))}: {};
class Catalogo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      elementos: [],
      pageSize: 100,
      test: this.categorias_object,
      hiddenModals: false,
      loadingProgress: 0,
      message: "",
      ErrorMessage: [],
      showErrormessage: false,
      selectedRow: -1,
      alertasN: {},
      gpsN: {},
      movsGpsEstatus: {},
      funcionalidadesCol: [],
      columnasPageable: [],
      buscar: "",
      buscarTs: null,
      movimientoAcumuladores: {},
      AscDesc: true,
      metodo: "get",
      topics: [],
      excelRender: false,
      movActToExpor: [],
      Navigator: false,
      colorFilter: "todos",
      ruteadorModal: null,
      filtroHorario: null,
      autoRefreshActive: true,
      autoRefreshing: false,
      lastRefreshTime: null,
    };
    this.usuariosLogObject = {
      idBitacoraMonitoreo: 0,
      idUsuario: 0,
      idMovimiento: 0,
      accionFecha: "",
      descripcion: "",
      idPlataformaTipo: 1,
    };
    this.AscDesc = true;
    this.ErrorMessage = "";
    this.ErrorMessageArray = [];
    this.catalogo = this.props.Ctlogo;
    this.catalogoTem = "";
    this.Catalogo_form = this.props.FCtlogo;
    this.tamanio = this.props.tamanio;
    this.updateStatus_elementos = this.updateStatus_elementos.bind(this);
    this.getfuntion = this.getfuntion.bind(this);
    this.get_Store_Elements = null; //this.props.plataformas_object;//update_Store_Elements
    this.update_Store_Elements = null; //this.props.plataformas_update;
    this.getMensage = false;
    this.movimientoAcumuladores = {};
    this.mensaje = {
      mensaje: "",
      plataforma: "",
      corredor: "",
      vista: "",
      data: null,
      accion: "get",
    };
    this.usuariosCorredores = [];
    this.movPatio = [];
  }

  hideNav = () => {
    this.setState((prev) => ({
      Navigator: !prev.Navigator,
    }));
  };

  estaPrivilegioActivo = (clave) => {
    var privilegios = this.props.privilegios_object;
    var perfil = JSON.parse(sessionStorage.getItem("perfil"));
    for (let i = 0; i < privilegios.length; i++) {
      if (privilegios[i].clave === clave) {
        if (
          perfil.privilegios.filter(
            (word) => word.idPrivilegio == privilegios[i].id
          ).length > 0
        ) {
          return true;
        } else {
          return false;
        }
        break;
      }
    }
  };

  componentDidUpdate = (prevProps) => {
    if (this.props.plataforma !== prevProps.plataforma) {
      this.setState({ loadingProgress: 0 });
      this.detenerAutoRefresh();
      this.cargarMovimientosPaginados(0);
    }
    if (this.props.idToFilter !== prevProps.idToFilter && this.props.idToFilter) {
      this.setState({
        buscar: this.props.idToFilter.id.toString(),
        buscarTs: this.props.idToFilter.ts,
      });
    }
    if (this.props.alertasN !== prevProps.alertasN) {
      this.setState({ alertasN: this.props.alertasN });
    }
    if (this.props.gpsNavieroReciente !== prevProps.gpsNavieroReciente) {
      this.setState({ gpsN: this.props.gpsNavieroReciente });
    }
    if (this.props.movsGpsEstatus !== prevProps.movsGpsEstatus) {
      this.setState({ movsGpsEstatus: this.props.movsGpsEstatus });
    }
    if (this.props.columnas !== prevProps.columnas) {
      this.setState({ funcionalidadesCol: this.props.columnas }, () => {
        this.setState({ columnasPageable: this.getColumnasPageable() });
      });
    }
    if (this.props.usuariosCorredores !== prevProps.usuariosCorredores) {
      this.usuariosCorredores = this.props.usuariosCorredores;
      let topics =[]; //JSON.parse(JSON.stringify(this.state.topics));
      for (let item of this.props.usuariosCorredores) {
        if(this.props.plataforma.value === item.idPlataforma){
          topics.push("/topic/" + item.idPlataforma + "-" + item.idCorredor);
        }
      }
      this.setState({ topics: topics });
    }
    if (this.props.movPatio !== prevProps.movPatio) {

      var dataTemp = [];
      if (this.state.elementos) {
        this.state.elementos.map((filas, index) => {
          Object.keys(filas).forEach((key) => {
            if (!dataTemp[index]) {
              dataTemp[index] = {};
            }
            if (key !== "movimientoGps" && key !== "incidencia") {
              dataTemp[index][key] = [];
            }
            if (filas[key] !== null) {
              if (typeof filas[key] === "object") {
                switch (key) {
                  case "persona":
                    dataTemp[index][key] =
                      "" +
                      filas[key].nombre +
                      " " +
                      filas[key].aPaterno +
                      " " +
                      filas[key].aMaterno;
                    break;
                  case "movimientoGps":
                    filas[key].map((gps, indice) =>{

                      if(gps.gpsTipo && gps.gpsTipo.nombre){
                        dataTemp[index]["gps-" + gps.gpsTipo.nombre] = gps.gps.nombre;
                        dataTemp[index]["gps(Username)-" + gps.gpsTipo.nombre] = gps.gps.nombreUsuario;
                      }
                    });
                    break;
                  case "incidencias":
                    break;
                  case "idCliente":
                    dataTemp[index][key] = filas[key].nombre;
                    dataTemp[index]["Dirección cliente"] = filas[key].domicilio;
                    break;
                  default:
                    if (filas[key].nombre !== "" && filas[key].nombre) {
                      dataTemp[index][key] = filas[key].nombre;
                    } else {
                      if (filas[key].id !== "" && filas[key].id) {
                        dataTemp[index][key] = filas[key].id;
                      } else {
                        dataTemp[index][key] = "Vari(@)s ";
                      }
                    }
                }
              } else {
                switch (key) {
                  case "creationDate":
                    dataTemp[index][key] = timeToDateFill(filas[key]).toString();
                    break;
                  case "variables":
                    //dataTemp[index][key] = filas[key].nombre;
                    dataTemp[index]["load"] = this.getValor( {...filas}, "variables.load" );
                    break;
                  default:
                    dataTemp[index][key] = filas[key];
                    break;
                }
              }
            } else {
              dataTemp[index][key] = "";
            }
          });
        });
      }
      if (this.state.elementos) {
        this.state.elementos.map((mov, index) => {
          if (movsArray[mov.id]) {
            if (movsArray[mov.id]["movimientoGps"]) {
              if (movsArray[mov.id]["movimientoGps"].length === 0) {
                if (this.props.movPatio[mov.id]) {
                  if (
                    movsArray[parseInt(this.props.movPatio[mov.id].esFull, 10)]
                  ) {
                    movsArray[parseInt(this.props.movPatio[mov.id].esFull, 10)][
                      "movimientoGps"
                    ].map((gps, indice) =>{
                      dataTemp[index]["gps-" + gps.gpsTipo.nombre] = gps.gps.nombre + ".";
                      dataTemp[index]["gps(Username)-" + gps.gpsTipo.nombre] = gps.gps.nombreUsuario + ".";
                    });
                  }
                }
              } else {
                //si el gps es full, buscar en el otro mov un gps distinto de full
                if (movsArray[mov.id]["movimientoGps"].length === 1) {
                  //primero validamos que solo tenga un gps
                  if (
                    movsArray[mov.id]["movimientoGps"].filter((word) =>
                      word.gps.nombre.toUpperCase().includes("FULL")
                    ).length === 1
                  ) {
                    //detectamos si hay full
                    if (this.props.movPatio[mov.id]) {
                      if (
                        movsArray[
                          parseInt(this.props.movPatio[mov.id].esFull, 10)
                        ]
                      ) {
                        movsArray[
                          parseInt(this.props.movPatio[mov.id].esFull, 10)
                        ]["movimientoGps"].map((gps, indice) =>{
                          dataTemp[index]["gps-" + gps.gpsTipo.nombre] = gps.gps.nombre + ".";
                          dataTemp[index]["gps(Username)-" + gps.gpsTipo.nombre] = gps.gps.nombreUsuario + ".";
                      });
                      }
                    }
                  }
                }
              }
            }
          }
          if (this.props.movPatio[mov.id]) {
            dataTemp[index]["full"] = this.props.movPatio[mov.id].esFull;
            dataTemp[index]["operador"] =
              this.props.movPatio[mov.id].operadorNombre;
            dataTemp[index]["telefono"] =
              this.props.movPatio[mov.id].operadorContacto;
            dataTemp[index]["Placa tractor"] =
              this.props.movPatio[mov.id].tractorPlaca;
            dataTemp[index]["Placa remolque"] =
              this.props.movPatio[mov.id].remolquePlaca;
            dataTemp[index]["economicor"] =
              this.props.movPatio[mov.id].economicor;
            dataTemp[index]["economicot"] =
              this.props.movPatio[mov.id].economicot;
          }
        });
      }
      this.setState({ movActToExpor: dataTemp });
    }
  };

  updateMessage = (sms) => {
    this.setState({ message: sms });
  };

  componentDidMount = () => {
    if (this.catalogo !== "" || this.catalogo !== null) {
      Object.keys(this.props.catalogos).forEach((key) => {
        if (this.catalogo === this.props.catalogos[key]) {
        }
        switch (this.props.catalogos[key]) {
          case "navieraMovimientos": {
            this.update_Store_Elements = this.props.movimientos_naviera_update;
            this.cargarMovimientosPaginados(0);

            break;
          }
          case "movimientosTipo": {
            this.update_Store_Elements = this.props.movimientosTipo_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "clientes": {
            this.update_Store_Elements = this.props.clientes_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              "catalogos/" + this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "navieras": {
            this.update_Store_Elements = this.props.navieras_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "localidades": {
            this.update_Store_Elements = this.props.localidades_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "otd": {
            this.update_Store_Elements = this.props.otd_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "plataformas": {
            this.update_Store_Elements = this.props.plataformas_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "rutasEstatus": {
            this.update_Store_Elements = this.props.rutasEstatus_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "transportistas": {
            this.update_Store_Elements = this.props.transportistas_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              "catalogos/" + this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "etiquetas":
            //if (!this.estaPrivilegioActivo("etiquetas_listar")) break;
            this.update_Store_Elements = this.props.etiquetas_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          case "funcionalidades": {
            this.update_Store_Elements = this.props.funcionalidades_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "privilegios": {
            this.update_Store_Elements = this.props.privilegios_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "operacionesEstatus": {
            this.update_Store_Elements = this.props.operacionesEstatus_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "operacionesTipo": {
            this.update_Store_Elements = this.props.operacionesTipo_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "operadores": {
            this.update_Store_Elements = this.props.operadores_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "incidencias": {
            if (!this.estaPrivilegioActivo("incidencias_listar")) break;
            this.update_Store_Elements = this.props.incidencias_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }

          default:
            return;
        }
      });
    }
  };

  hiddenmodal = () => {
    this.setState({ hiddenModals: !this.state.hiddenModals });
  };

  componentWillUnmount = () => {
    this.detenerAutoRefresh();
  };

  getfuntion = (
    metodo = "get",
    params = [],
    id = "",
    arraytoUpdate = [],
    catalogoTem = this.catalogo,
    storeFunction = this.update_Store_Elements
  ) => {
    this.usuariosLogObject.idMovimiento = params;
    let objTemp = params;
    if (catalogoTem !== "") {
      Crud_Catalogos(
        catalogoTem,
        this.catalogo,
        metodo,
        id,
        params,
        storeFunction,
        this.state.elementos,
        this.hiddenmodal,
        arraytoUpdate
      )
        .then((returnVal) => {
          this.mensaje.accion = metodo;
          this.mensaje.vista = catalogoTem;
          this.setState({ metodo: metodo });
          switch (metodo) {
            case "get":
              {
                if (
                  catalogoTem.includes(this.catalogo + "/usuario/" + user.id)
                ) {
                  this.updateStatus_elementos();
                  this.setState({ loadingProgress: 100 });
                  setTimeout(() =>{
                    this.mostrarAlertas5min();
                    this.setState({ excelRender: true });
                  }, 1000 * 1 );
                }
              }
              break;
            case "post":
              {
                this.mensaje.data = returnVal;
                this.mensaje.corredor = returnVal.idCorredor.id;
                this.mensaje.plataforma = returnVal.idPlataforma.id;
                this.mensaje.mensaje =
                  "Nuevo movimiento (" +
                  returnVal.id +
                  ", plataforma: " +
                  returnVal.idPlataforma.nombre +
                  ")";
                this.props.updateStatusMensaje(true);
                // Actualizar array directamente (fallback si websocket falla)
                this.actualizarMovimientoEnArray(returnVal, "post");
                this.usuariosLogObject.idBitacoraMonitoreo = 1;
                this.usuariosLogObject.idUsuario = user.id;
                this.usuariosLogObject.idMovimiento = returnVal.id;
                this.usuariosLogObject.idPlataformaTipo = 1;
                this.usuariosLogObject.accionFecha = timeToDateFill(new Date());
                this.usuariosLogObject.descripcion = "Nuevo Movimiento";
                Crud_Catalogos(
                  "usuariosLog",
                  this.catalogo,
                  "post",
                  "",
                  this.usuariosLogObject
                );
              }
              break;
            case "put":
              {
                this.mensaje.data = returnVal.data;
                this.mensaje.corredor = returnVal.data.idCorredor.id;
                this.mensaje.plataforma = returnVal.data.idPlataforma.id;
                this.mensaje.mensaje =
                  "Actualización (" +
                  returnVal.data.id +
                  ", plataforma: " +
                  returnVal.data.idPlataforma.nombre +
                  ")";
                this.props.updateStatusMensaje(true);
                // Actualizar array directamente (fallback si websocket falla)
                this.actualizarMovimientoEnArray(returnVal.data, "put");
                this.usuariosLogObject.idBitacoraMonitoreo = 1;
                this.usuariosLogObject.idUsuario = user.id;
                this.usuariosLogObject.idMovimiento = objTemp.id;
                this.usuariosLogObject.idPlataformaTipo = 1;
                this.usuariosLogObject.accionFecha = timeToDateFill(new Date());
                this.usuariosLogObject.descripcion =
                  "Actualización de Movimiento";
                /*
              if (objTemp.idOperacionEstatus.id === 1) {
                this.usuariosLogObject.idBitacoraMonitoreo = 5;
                this.usuariosLogObject.descripcion = "Se finaliza movimiento";
              }*/
                Crud_Catalogos(
                  "usuariosLog",
                  this.catalogo,
                  "post",
                  "",
                  this.usuariosLogObject
                );
              }
              break;
            case "delete":
              {
                this.usuariosLogObject.idBitacoraMonitoreo = 10;
                this.usuariosLogObject.idUsuario = user.id;
                this.usuariosLogObject.accionFecha = timeToDateFill(new Date());
                this.usuariosLogObject.idPlataformaTipo = 1;
                this.usuariosLogObject.descripcion =
                  "Delete: id:" + returnVal.id;
                Crud_Catalogos(
                  "usuariosLog",
                  this.catalogo,
                  "post",
                  "",
                  this.usuariosLogObject
                );
              }
              break;
            default:
              break;
          }
        })
        .catch((err) => {
          console.log("Error: " + err);
          if (err.response) {
            this.setState({ showErrormessage: true });
            this.ErrorMessage = Crud_error(err.response.status, catalogoTem);
            this.ErrorMessageArray.push(
              <Alert type="danger" icon="alert-octagon">
                {" "}
                {this.ErrorMessage}{" "}
              </Alert>
            );
            this.setState({ ErrorMessage: this.ErrorMessageArray });
          } else {
            this.setState({ showErrormessage: true });
            this.ErrorMessage = Crud_error(1, catalogoTem);
            this.ErrorMessageArray.push(
              <Alert type="danger" icon="alert-octagon">
                {" "}
                {this.ErrorMessage}{" "}
              </Alert>
            );
            this.setState({ ErrorMessage: this.ErrorMessageArray });
          }
        });
    }
  };
  cargarMovimientosPaginados = (pagina, acumulados = []) => {
    const mtipo = this.props.mtipo || 0;
    const gpsTipo = this.props.gpsTipo || 0;
    const idPlataforma = this.props.plataforma ? this.props.plataforma.value : 0;
    const maxMovimientos = 4000;
    const url = "navieraMovimientos/usuario/" + user.id + "/" + mtipo + "/" + gpsTipo + "/pagina/" + pagina + "/total/" + this.state.pageSize + "?idPlataforma=" + idPlataforma;
    Crud_Catalogos(url, "", "get", "", [])
      .then((res) => {
        const todos = acumulados.concat(res.content || []);
        const progress = Math.round(((pagina + 1) / (res.totalPages || 1)) * 100);
        this.setState({ elementos: [...todos],loadingProgress: progress });
        this.props.movimientos_naviera_update(todos);
        this.props.setMovimientosNavieros(todos);
        if (todos.length >= maxMovimientos || pagina >= (res.totalPages - 1)) {
          this.setState({ loadingProgress: 100 });
          movsArray = {};
          todos.forEach((m) => { if (!movsArray[m.id]) { movsArray[m.id] = m; } });
          setTimeout(() => {
            this.mostrarAlertas5min();
            this.setState({ excelRender: true });
            this.iniciarAutoRefresh();
          }, 1000);
        } else {
          setTimeout(() => this.cargarMovimientosPaginados(pagina + 1, todos), 100);
        }
      })
      .catch((err) => {
        console.error("Error al cargar movimientos paginados:", err);
        if (acumulados.length > 0) {
          this.setState({ elementos: acumulados, loadingProgress: 100 });
          this.props.setMovimientosNavieros(acumulados);
        } else {
          this.setState({ loadingProgress: 100, elementos: [] });
        }
      });
  };

  // --- AUTOREFRESH SILENCIOSO ---
  autoRefreshInterval = null;
  isAutoRefreshing = false;

  iniciarAutoRefresh = () => {
    if (this.autoRefreshInterval) return;
    const INTERVALO_MS = 1000 * 40 * 1; // cada 3 minutos
    this.autoRefreshInterval = setInterval(() => {
      if (!this.isAutoRefreshing && this.state.loadingProgress >= 100) {
        this.autoRefreshSilencioso();
      }
    }, INTERVALO_MS);
  };

  detenerAutoRefresh = () => {
    if (this.autoRefreshInterval) {
      clearInterval(this.autoRefreshInterval);
      this.autoRefreshInterval = null;
    }
  };

  autoRefreshSilencioso = (pagina = 0, acumulados = []) => {
    this.isAutoRefreshing = true;
    if (pagina === 0) this.setState({ autoRefreshing: true });
    const mtipo = this.props.mtipo || 0;
    const gpsTipo = this.props.gpsTipo || 0;
    const idPlataforma = this.props.plataforma ? this.props.plataforma.value : 0;
    const maxMovimientos = 4000;
    const url = "navieraMovimientos/usuario/" + user.id + "/" + mtipo + "/" + gpsTipo + "/pagina/" + pagina + "/total/" + this.state.pageSize + "?idPlataforma=" + idPlataforma;

    Crud_Catalogos(url, "", "get", "", [])
      .then((res) => {
        const todos = acumulados.concat(res.content || []);
        if (todos.length >= maxMovimientos || pagina >= (res.totalPages - 1)) {
          // Merge inteligente: actualizar sin resetear la UI
          this.mergeMovimientos(todos);
          this.isAutoRefreshing = false;
          this.setState({ autoRefreshing: false, lastRefreshTime: new Date() });
        } else {
          setTimeout(() => this.autoRefreshSilencioso(pagina + 1, todos), 100);
        }
      })
      .catch((err) => {
        console.warn("AutoRefresh silencioso falló:", err);
        this.isAutoRefreshing = false;
        this.setState({ autoRefreshing: false });
      });
  };

  mergeMovimientos = (nuevos) => {
    const actuales = this.state.elementos;

    let hayCambios = actuales.length !== nuevos.length;
    const merged = nuevos.map((m) => {
      const actual = movsArray[m.id];
      if (!actual) { hayCambios = true; return m; }
      if (this.movimientoCambio(actual, m)) { hayCambios = true; return m; }
      return actual;
    });

    if (hayCambios) {
      movsArray = {};
      merged.forEach((m) => { movsArray[m.id] = m; });
      this.props.movimientos_naviera_update(merged);
      this.setState({ elementos: merged });
      this.props.setMovimientosNavieros(merged);
    }
  };

  movimientoCambio = (a, b) => {
    // Campos objeto (comparar por id)
    const objFields = [
      'idOperacionEstatus','idPlataforma','idNaviera','idCliente','idClienteNaviero',
      'idCorredor','idLocalidad','idMovimientoTipo','idOperacionTipo','idTransportista',
      'idRuta','idOtd','idResponsableMovimiento'
    ];
    for (let f of objFields) {
      if ((a[f]?.id) !== (b[f]?.id)) return true;
    }
    // Campos escalares y fechas
    const scalarFields = [
      'booking','po','contenedor','sello','destino','nota','viaje','cp','referencia',
      'eco','modalidad','empacador','estatusActual','serviceOrder','woInstruction',
      'tipoOperacion','contenedorTipo','contenedorSize','entregaVacio','vip',
      'sencilloFull','actualizarFull','reaccion','ontime','delay','wti6h','transit',
      'incidencia','variables',
      // Horarios (ActualizarHorariosNavierosV2)
      'citaProgramada','citaProgramadaTerminal','citaColocacionGps','horaMaximaSalida',
      'arriboTerminalVacio','salidaTerminalLleno','arriboClienteLleno','salidaClienteVacio',
      'arriboDirecionCarga','arriboTerminalVacio2','asignacionPiloto','inicioRuta',
      'inicioRutaVacio','ingresoCliente','ingresoBodegaCarga','despachoPredioCliente',
      'llegadaFrontera','salidaFrontera','arriboAduana','salidaAduana','retiroContenedor',
      'arriboClienteVacio','salidaClienteLleno','arriboTerminalCargado','salidaPredioVacio',
      'citaFechaDespacho','entradaCiudadPortuaria','arriboPatioLinea','salidaTerminalVacio',
      'inicioDeCarga','asignacionRampa','reporteCentroCarga',
      'asignacionCortinaCentroCarga','entregaDocumentosControlTower',
      'entregaDocumentos','entregaDePods'
    ];
    for (let f of scalarFields) {
      if (a[f] !== b[f]) return true;
    }
    return false;
  };
  // --- FIN AUTOREFRESH ---

  updateStatus_elementos = (elementosDirectos) => {
    const elementos = elementosDirectos || this.props.movimientos_naviera_object;
    this.setState({ elementos });
    this.props.setMovimientosNavieros(elementos);
    movsArray = {};
    elementos.map((m, inx) => {
      if (!movsArray[m.id]) {
        movsArray[m.id] = m;
      }    
    });
  };

  actualizarMovimientoEnArray = (movimiento, accion) => {
    let elementos = [...this.state.elementos];
    if (accion === "delete") {
      elementos = elementos.filter((m) => m.id !== movimiento.id);
    } else if (accion === "put") {
      elementos = elementos.map((m) => m.id === movimiento.id ? movimiento : m);
    } else if (accion === "post") {
      if (!elementos.find((m) => m.id === movimiento.id)) {
        elementos.push(movimiento);
      }
    }
    if (accion === "delete") {
      delete movsArray[movimiento.id];
    } else {
      if (!movsArray[movimiento.id]) movsArray[movimiento.id] = movimiento;
      else movsArray[movimiento.id] = movimiento;
    }
    this.props.movimientos_naviera_update(elementos);
    this.setState({ elementos }, () => {
      this.props.setMovimientosNavieros(elementos);
    });
  };

  refreshMovimientoById = (idMovimiento) => {
    Crud_Catalogos("navieraMovimientos/" + idMovimiento, "", "get", "", [])
      .then((returnVal) => {
        if (returnVal && returnVal.id) {
          const existe = this.state.elementos.find((m) => m.id === returnVal.id);
          this.actualizarMovimientoEnArray(returnVal, existe ? "put" : "post");
        }
      })
      .catch((err) => console.error("Error al refrescar movimiento:", err));
    // También actualizar movPatio
    
    Crud_Catalogos("movimientosPatio/idMovimiento/" + idMovimiento, "", "get", "", [])
      .then((movPatioData) => {
        if (movPatioData && this.props.updateMovPatio) {
          let updated = { ...this.props.movPatio };
          updated[movPatioData.idMovimiento] = movPatioData;
          this.props.updateMovPatio(updated);
        }
      })
      .catch((err) => console.error("Error al refrescar movPatio:", err));
  };


  getFuncionalidadGeneral = (elemento) => {
    var BreakException = {};
    var resultado = false;

    try {
      Object.keys(this.props.PlataformasPerfiles).forEach((key, indice) => {
        if (this.props.PlataformasPerfiles[key].funcionalidades) {
          for (let item of this.props.PlataformasPerfiles[key]
            .funcionalidades) {
            if (item.nombre == elemento) {
              resultado = true;
              throw BreakException;
            }
          }
        }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
      return resultado;
    }
    return false;
  };

  tieneTempoizadorActivo = (idMovimiento) => {
    if (!this.props.tiempos || !Array.isArray(this.props.tiempos)) {
      return false;
    }
    
    return this.props.tiempos.some(temporizador => 
      temporizador.idMovimiento === idMovimiento
    );
  };

  validarMovimientosLocalesAnteriores = async (movimiento) => {
    try {
      const idGps = movimiento.movimientoGps?.[0]?.gps?.id;
            
      if (!idGps) {        
        return { hayAnteriores: false, movimientosAnteriores: [] };
      }

      const response = await Crud_Catalogos(
        "movimientosPatio/localesTerminarMovimiento/" + idGps,
        "movimientosPatio",
        "get",
        "",
        [],
        "",
        "",
        "",
        []
      );
      
      //console.log("Respuesta completa del API:", response);
      //console.log("Movimientos en orden:", response.map(m => ({ idMovimiento: m.idMovimiento, index: response.indexOf(m) })));

      const movimientoActualIndex = response.findIndex(
        movPatio => movPatio.idMovimiento === movimiento.id
      );   

      if (movimientoActualIndex <= 0) {
        //console.log("Movimiento no encontrado o es el primero, retornando false");
        return { hayAnteriores: false, movimientosAnteriores: [] };
      }

      const movimientosQueDebenTerminarsePrimero = response.slice(0, movimientoActualIndex);
      //console.log("Movimientos que deben terminarse primero:", movimientosQueDebenTerminarsePrimero.map(m => m.idMovimiento));

      return {
        hayAnteriores: movimientosQueDebenTerminarsePrimero.length > 0,
        movimientosAnteriores: movimientosQueDebenTerminarsePrimero
      };
    } catch (error) {
      console.error("Error al validar movimientos locales anteriores:", error);
      return { hayAnteriores: false, movimientosAnteriores: [] };
    }
  };

  mostrarAlertas5min =()=>{
    if( this.state.elementos && this.state.elementos.length){
      avisosEstatusNav= localStorage.getItem("avisosEstatusNav")? {...JSON.parse(localStorage.getItem("avisosEstatusNav"))}: {};
      if( Object.keys(avisosEstatusNav).length ){
        Object.keys(avisosEstatusNav).forEach((idMov) => {
          const movimientos= [...this.state.elementos];
          if( movimientos.filter(mov=> mov.id === Number(idMov)).length === 0 ){
            delete avisosEstatusNav[idMov];
          }
          if( avisosEstatusNav[idMov] ){
            Object.keys(avisosEstatusNav[idMov]).forEach((a) => {
              if( !avisosEstatusNav[idMov][a].acuse ){
                this.crearAlerta(avisosEstatusNav[idMov][a]);
              }
            });
          }
        });
        localStorage.setItem("avisosEstatusNav", JSON.stringify(avisosEstatusNav));
      }
    }
    setTimeout(() => {
      this.mostrarAlertas5min();
    }, (1000*60*5));//cada 5 min
  }

  crearAlerta=( aviso )=>{
    if(!aviso.acuse)
      NotificationManager.warning(
        <div>
          <p> { aviso.texto } </p>
          <span className="text-primary btn"
            onClick={()=>{
              this.setState({buscar : aviso.idMov, buscarTs: Date.now()});
              avisosEstatusNav[aviso.idMov][aviso.aviso].acuse= true;
              localStorage.setItem("avisosEstatusNav", JSON.stringify(avisosEstatusNav));
            }}>
            Atender
          </span>
          <span className="text-primary btn" onClick={()=>{ 
            confirmAlert({
              title: "Atención",
              message:
                "Estoy enterado y ya se seguimiento al mov " + aviso.idMov+" " +aviso.texto ,
              buttons: [
                {
                  label: "Confirmar",
                  onClick: () => {
                    avisosEstatusNav[aviso.idMov][aviso.aviso].acuse= true;
                    localStorage.setItem("avisosEstatusNav", JSON.stringify(avisosEstatusNav));
                  },
                },
                {
                  label: "Cancelar",
                  onClick: () => {
                    return false;
                  },
                },
              ],
            });
            }}>
            Atendida
          </span>
          <span className="text-primary btn" //onClick={()=>{ alert("Estoy ignorando la alerta")}}
          >
            Ignorar
          </span>
        </div>,
        aviso.titulo,
        (1000*60*3));
  }
  getValor=(dataObj, columna)=>{
    const campo= columna.split(".");
    const dataObjTemp= {...dataObj};
    if(dataObjTemp.variables && typeof dataObjTemp.variables === "string" && dataObjTemp.variables.includes("{")){
      dataObjTemp.variables= safeJsonParse(dataObjTemp.variables, dataObjTemp.variables);
    }
    let valor= 'undefined';
    switch (campo.length) {
      case 1:
        valor= dataObjTemp[campo[0]];
        break;
      case 2:
        if(dataObjTemp[campo[0]]){
          valor= dataObjTemp[campo[0]][campo[1]];
        }
        break;
      case 3:
        if(dataObjTemp[campo[0]] && dataObjTemp[campo[0]][campo[1]]){
          valor= dataObjTemp[campo[0]][campo[1]][campo[2]];
        }                                          
        break;
      case 4:
        if(dataObjTemp[campo[0]] && dataObjTemp[campo[0]][campo[1]] && dataObjTemp[campo[0]][campo[1]][campo[2]]){
          valor= dataObjTemp[campo[0]][campo[1]][campo[2]][campo[3]];
        }
        break;                                      
      default: valor= 'undefined';
        break;
    }
    //{dataObjTemp[columna.columna]}
    return valor;
  }
  getListaFiltrada = () => {
    if (!this.state.elementos) return [];
    let lista = this.state.elementos;
    if (this.state.filtroHorario) {
      const { campo, tipo } = this.state.filtroHorario;
      const ahora = new Date().getTime();
      const dosHoras = 1000 * 60 * 60 * 2;
      lista = lista.filter(m => {
        if (!m[campo]) return false;
        const diff = new Date(m[campo]).getTime() - ahora;
        if (diff <= 0) return false;
        return tipo === 'menor' ? diff < dosHoras : diff >= dosHoras;
      });
    }
    return lista;
  };

  handleSelectMovimiento = async (elemento) => {
    try {
      const movPatioData = await Crud_Catalogos(
        `movimientosPatio/idMovimiento/${elemento.id}`,
        "movimientosPatio",
        "get",
        "",
        [],
        "",
        "",
        "",
        []
      );
      const tieneMovimientoLocal = movPatioData?.movimientoLocal;
      if (tieneMovimientoLocal) {
        const validacion = await this.validarMovimientosLocalesAnteriores(elemento);
        if (validacion.hayAnteriores) {
          const idsMovimientosAnteriores = validacion.movimientosAnteriores.map(mov => mov.idMovimiento);
          const movimientoEnRuta = this.state.elementos.find(
            elem => idsMovimientosAnteriores.includes(elem.id) && elem.idOperacionEstatus.id === 2
          );
          const movimientosIds = validacion.movimientosAnteriores
            .map(mov => mov.idMovimiento)
            .join(", ");
          const mensajeConColores = (
            <div>
              <p>
                No debes dar seguimiento al movimiento{' '}
                <span style={{color: 'blue', fontWeight: 'bold'}}>
                  {elemento.id}
                </span>
              </p>
              <p>
                Existen movimientos locales anteriores que deben terminarse primero, ya que tienen el mismo GPS asignado:{' '}
                <span style={{color: 'green', fontWeight: 'bold'}}>
                  {movimientosIds}
                </span>
              </p>
              {movimientoEnRuta && (
                <p>
                  <strong>Movimiento prioritario:</strong>{' '}
                  <span style={{color: 'red', fontWeight: 'bold'}}>
                    {movimientoEnRuta.id}
                  </span>
                  {' '}(En Ruta - debe darse seguimiento primero)
                </p>
              )}
            </div>
          );
          confirmAlert({
            title: "Movimientos Locales Anteriores",
            message: mensajeConColores,
            buttons: [
              {
                label: "Entendido",
                onClick: () => {
                  this.props.setMovimiento(elemento);
                  this.setState({ selectedRow: elemento.id });
                },
              },
              {
                label: "Cancelar",
                onClick: () => { return false; },
              },
            ],
          });
          return;
        }
      }
    } catch (error) {
      console.error(`Error al consultar movPatio para ${elemento.id}:`, error);
    }
    this.props.setMovimiento(elemento);
    this.setState({ selectedRow: elemento.id });
  };

  renderColumnaObject = (elemento, columnaName) => {
    const valor = elemento[columnaName];
    if (!valor) return "";
    if (Array.isArray(valor)) {
      if (valor.length > 1) {
        return valor[valor.length - 1]["nombre"] + " ...";
      }
    }
    if (typeof valor === "object") {
      switch (columnaName) {
        case "username": return valor["username"] || "";
        case "idOtd":
          return timeToMilisegundos(elemento.delay) > 0 ? (
            <div className="badge bg-secondary" data-toggle="tooltip" data-placement="top" title={valor["nombre"]}>
              <Icon name="message-square" />
            </div>
          ) : "";
        case "idPatioVacio": return valor["patio"] || "";
        case "idTransportista": return valor["nombreCorto"] || "No se encontró nombre corto";
        default: return valor["nombre"] || "";
      }
    }
    return valor;
  };

  getColumnasPageable = () => {
    if (!this.state.funcionalidadesCol || !this.state.funcionalidadesCol.length) return [];
    const cols = this.state.funcionalidadesCol.map((col) => {
      const columnaName = col.columna;
      const base = { columna: columnaName, label: col.label || col.columna };
      switch (columnaName) {
        case "estatus":
        case "vip":
          return { ...base, valor: (e) => e[columnaName] ? "true" : "false", form: (e) => <Form.Switch type="Checkbox" checked={e[columnaName]} /> };
        case "incidencia":
          return { ...base, valor: (e) => e["incidencia"] || "", form: (e) => {
              let diferencia = 0;
              if (e["incidencia"] && new Date().getTime() > new Date(e["incidencia"].trim().substr(0, 19)).getTime()) {
                diferencia = (new Date().getTime() - new Date(e["incidencia"].trim().substr(0, 19)).getTime()) / 1000 / 60 / 60;
              }
              let colorTem = diferencia > 1 ? "rgba(241, 111, 111, 0.67)" : "rgba(73, 223, 67, 0.29)";
              if (e.incidenciaUsuario === 0) colorTem = "rgba(107, 194, 245, 0.56)";
              return (<div className="row" style={{ fontSize: "80%", backgroundColor: colorTem }}><div style={{ flex: 1 }}>{e["incidencia"]}</div>{this.tieneTempoizadorActivo(e.id) && (<div style={{ marginLeft: "5px" }}><i className="fa fa-hourglass" style={{ color: "#ff0000", fontSize: "16px" }} title="Temporizador activo" /></div>)}</div>);
            }
          };
        case "wo":
          return { ...base, valor: (e) => e["po"] || "", form: (e) => e["po"] || "" };
        case "ontime":
          return { ...base, form: (e) => (<div className="row" style={timeToMilisegundos(e.ontime) > 0 ? { backgroundColor: "green" } : {}}>{e.ontime}</div>) };
        case "delay":
          return { ...base, form: (e) => (<div className="row" style={timeToMilisegundos(e.delay) > 0 ? { backgroundColor: "red" } : {}}>{e.delay}</div>) };
        case "origen":
          return { ...base,
            valor: (e) => { const imp = e.idMovimientoTipo.nombre.toUpperCase().includes("IMPORTACI"); return (imp || [1678].includes(e.idPlataforma.id)) ? (e.idCorredor ? e.idCorredor.nombre : "") : (e.destino || ""); },
            form: (e) => { const imp = e.idMovimientoTipo.nombre.toUpperCase().includes("IMPORTACI"); return (imp || [1678].includes(e.idPlataforma.id)) ? (e.idCorredor ? e.idCorredor.nombre : "") : (e.destino || ""); }
          };
        case "destino":
          return { ...base,
            valor: (e) => { const imp = e.idMovimientoTipo.nombre.toUpperCase().includes("IMPORTACI"); return (imp || [1678].includes(e.idPlataforma.id)) ? (e.destino || "") : (e.idCorredor ? e.idCorredor.nombre : ""); },
            form: (e) => { const imp = e.idMovimientoTipo.nombre.toUpperCase().includes("IMPORTACI"); return (<span>{(imp || [1678].includes(e.idPlataforma.id)) ? (e.destino || "") : (e.idCorredor ? e.idCorredor.nombre : "")}{e.changeDestino ? <i className="fa fa-road fa-2xl" style={{transform:"scale(1.9, 1.5)", color:"red", margin: "0 16px"}}></i> : null}</span>); }
          };
        case "password":
          return { ...base, valor: () => "*******", form: () => "*******" };
        case "gps":
          return { ...base,
            valor: (e) => e.movimientoGps && e.movimientoGps.length ? e.movimientoGps.map(g => g.gps.nombre).join(", ") : "",
            form: (e) => {
              if (this.state.movsGpsEstatus) {
                let mPatioTemp;
                if (this.props.movPatio[e.id]) { mPatioTemp = movsArray[parseInt(this.props.movPatio[e.id].esFull, 10)] || []; }
                if (e.movimientoGps) {
                  if (e.movimientoGps.length) {
                    return e.movimientoGps.map((gpsTem, i) => (
                      this.state.movsGpsEstatus[gpsTem.gps.id] ?
                        <div key={i}><div className="badge1" style={{ color: this.state.movsGpsEstatus[gpsTem.gps.id].iconBattery.color, fontSize: "80%" }}>{this.state.movsGpsEstatus[gpsTem.gps.id].nombre}</div><div className="badge" data-toggle="tooltip" data-placement="top" title={this.state.movsGpsEstatus[gpsTem.gps.id].nombre + ", " + this.state.movsGpsEstatus[gpsTem.gps.id].nivel_bateria + " %"} style={{ color: this.state.movsGpsEstatus[gpsTem.gps.id].iconBattery.color, fontSize: "70%" }}><span className={this.state.movsGpsEstatus[gpsTem.gps.id].iconBattery.icono}></span></div><div className="badge" data-toggle="tooltip" data-placement="top" title={this.state.movsGpsEstatus[gpsTem.gps.id].ultimo_reporte} style={{ color: this.state.movsGpsEstatus[gpsTem.gps.id].iconTime.color, fontSize: "70%" }}><span className={this.state.movsGpsEstatus[gpsTem.gps.id].iconTime.icono}></span></div></div>
                      : <div key={i}>{gpsTem.gps.nombre}</div>
                    ));
                  } else {
                    if (mPatioTemp && mPatioTemp.movimientoGps) { return mPatioTemp.movimientoGps.map((gpsTem, i) => (<div key={i}>{gpsTem.gps.nombre}</div>)); }
                    return "";
                  }
                }
                return "";
              }
              return e.movimientoGps ? e.movimientoGps.map((gpsTem, i) => (<div key={i}>{gpsTem.gps.nombre}</div>)) : "";
            }
          };
        case "alertas":
          return { ...base,
            valor: (e) => { if (this.state.alertasN && this.state.alertasN[e.id]) { let t = 0; Object.keys(this.state.alertasN[e.id]).forEach((k) => { t += this.state.alertasN[e.id][k].filter((w) => !w.alert.atendida).length; }); return t > 0 ? t.toString() : ""; } return ""; },
            form: (e) => {
              var nticacion = [];
              if (this.state.alertasN && this.state.alertasN[e.id]) {
                let semaforo = 0;
                Object.keys(this.state.alertasN[e.id]).forEach((key) => {
                  if (this.state.alertasN[e.id][key][0] && this.state.alertasN[e.id][key][0].tiempo) {
                    let timemil = timeToMilisegundos(this.state.alertasN[e.id][key][0].tiempo);
                    if (timemil > 0) { for (let al of this.state.alertasN[e.id][key]) { if (new Date(al.alert.fechaCreacion).getTime() + timemil < new Date().getTime()) { semaforo = 2; } else { let dif = new Date(al.alert.fechaCreacion).getTime() - new Date().getTime(); if (timemil - dif < 2 && dif > 0 && semaforo < 2) semaforo = 1; } } }
                  }
                  if (this.state.alertasN[e.id][key].filter((w) => !w.alert.atendida).length) {
                    nticacion.push(<div key={key} className="badge" data-toggle="tooltip" data-placement="top" title={this.state.alertasN[e.id][key][0].tipo + ", Tiempo de atención: " + timeToMilisegundos(this.state.alertasN[e.id][key][0].tiempo) / 1000 / 60 + " min"} style={{ color: this.state.alertasN[e.id][key][0].color, fontSize: "140%" }}><span className={"fa " + key}>{this.state.alertasN[e.id][key].filter((w) => !w.alert.atendida).length}</span></div>);
                  }
                });
                if (nticacion.length > 0) { return (<div className="row" style={{ backgroundColor: semaforo === 1 ? "rgba(228, 228, 98, 0.7)" : semaforo === 2 ? "rgba(241, 111, 111, 0.67)" : "rgba(73, 223, 67, 0.29)" }}><div className="badge col">{nticacion}</div></div>); }
              }
              return "";
            }
          };
        case "geocerca":
          return { ...base,
            valor: (e) => e.idCliente && e.idCliente.idGeocerca ? "Cliente con geocerca" : "Cliente sin geocerca",
            form: (e) => {
              return <div style={{ textAlign: "center" }}
                      className="btn"
                      data-toggle="tooltip"
                      data-placement="top"
                      title={e.idCliente && e.idCliente.idGeocerca? "Cliente con geocerca": "Cliente sin geocerca"} >
                { e.idCliente && e.idCliente.idGeocerca
                  ? <>🟣</>
                  : <i className="fa fa-circle-o" style={{ color: "purple", fontSize: "16px" }} />
                }
              </div>
            }
          };
        case "contenedorTipo":
          return { ...base,
            valor: (e) => { const t = { 1: "Seco", 2: "Refrigerado", 3: "Caja", 4: "Carga suelta" }; return e.idContenedorTipo?.nombre || t[e.contenedorTipo] || e.contenedorTipo || "-"; },
            form: (e) => { const t = { 1: "Seco", 2: "Refrigerado", 3: "Caja", 4: "Carga suelta" }; return e.idContenedorTipo?.nombre || t[e.contenedorTipo] || e.contenedorTipo || "-"; }
          };
        case "edit":
          return { ...base, valor: () => "", form: (e) => (<p style={{ width: "80px" }}><span className="float-left"><ModalLay resumirModal={this.props.resumeModal} funcionReanudar={this.props.functionReanudarModal} title="Modificar" name={<div className="badge" style={{ color: "green", fontSize: "120%" }} data-toggle="tooltip" data-placement="top" title="Editar movimiento">{!this.props.resumeModal && <span className="fa fa-edit"></span>}</div>} formulario={this.Catalogo_form} datosForm={{ accion: "modificar", elementos: e, getfuntion: this.getfuntion, stor: this.props, Fclose: this.hiddenmodal, refreshMovimiento: this.refreshMovimientoById }} /></span></p>) };
        case "eventos":
          return { ...base,
            valor: (e) =>{
              let eventos= [];
              for( let h of ['citaProgramadaTerminal','citaProgramada','horaMaximaSalida'] ){
                let resp= validarHorarios(e, h);
                if(resp.vencida)
                  eventos.push( resp.texto);
              }
              const estadia= validarEstadiaCorta(e);
              if(estadia.vencida)
                eventos.push( estadia.texto);
              return  eventos;
            },
            form: (e) => {
              let eventos = [];
              for (let h of ['citaProgramadaTerminal', 'citaProgramada','horaMaximaSalida']) { let resp = validarHorarios(e, h); if (resp.vencida) eventos.push(<li key={h} style={{ color: resp.colorTexto, fontSize: '14px' }} className="badge" data-toggle="tooltip" data-placement="top" title={resp.texto}><i className={resp.icono}></i></li>); }
              const estadia = validarEstadiaCorta(e);
              if (estadia.vencida) eventos.push(<li key="estadiaCorta" style={{ color: estadia.colorTexto, fontSize: '14px' }} className="badge" data-toggle="tooltip" data-placement="top" title={estadia.texto}><i className={estadia.icono}></i></li>);
              return <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>{eventos}</ul>;
            }
          };
        case "eta":
          return { ...base,
            valor: (e) => this.props.etasN[e.id] && this.props.etasN[e.id][2] ? this.props.etasN[e.id][2].total.toString() : "",
            form: (e) => { if (this.props.etasN[e.id] && this.props.etasN[e.id][2]) { return (<ModalLay tamanio={"90%"} title="Etas calculadas" name={<div className="badge bg-secondary"><Icon name="message-square" /> <span>{this.props.etasN[e.id][2].total}</span></div>} formulario={EtaCalculada} datosForm={{ idMovimento: e.id }} />); } return ""; }
          };
        case "economicor":
          return { ...base, valor: (e) => this.props.movPatio[e.id] ? this.props.movPatio[e.id].economicor || "" : "", form: (e) => this.props.movPatio[e.id] ? this.props.movPatio[e.id].economicor || "" : "" };
        case "economicot":
          return { ...base, valor: (e) => this.props.movPatio[e.id] ? this.props.movPatio[e.id].economicot || "" : "", form: (e) => this.props.movPatio[e.id] ? this.props.movPatio[e.id].economicot || "" : "" };
        case "remolquePlaca":
          return { ...base, valor: (e) => this.props.movPatio[e.id] ? this.props.movPatio[e.id].remolquePlaca || "" : "", form: (e) => this.props.movPatio[e.id] ? this.props.movPatio[e.id].remolquePlaca || "" : "" };
        case "tractorPlaca":
          return { ...base, valor: (e) => this.props.movPatio[e.id] ? this.props.movPatio[e.id].tractorPlaca || "" : "", form: (e) => this.props.movPatio[e.id] ? this.props.movPatio[e.id].tractorPlaca || "" : "" };
        case "referencia_facturacion":
          return { ...base,
            valor: (e) => { const v = safeJsonParse(e.variables, null); return v && v["referencia_facturacion"] ? v["referencia_facturacion"] : ""; },
            form: (e) => { const v = safeJsonParse(e.variables, null); return v && v["referencia_facturacion"] ? v["referencia_facturacion"] : ""; }
          };
        case "variables.reutilizar":
          return { ...base,
            valor: (e) => {
              const v = typeof e.variables === "string" ? safeJsonParse(e.variables, null) : e.variables;
              if (v && v.reutilizar === true) return "Sí reutiliza";
              return v && v.patio_de_vacio ? v.patio_de_vacio : "No reutiliza";
            },
            form: (e) => {
              const v = typeof e.variables === "string" ? safeJsonParse(e.variables, null) : e.variables;
              if (v && v.reutilizar === true) return "Sí reutiliza";
              return v && v.patio_de_vacio ? v.patio_de_vacio : "No reutiliza";
            }
          };
        default:
          //return base;
          if (columnaName.includes(".")) {
            console.log(base);
            //return base;
            return { ...base, valor: (e) => { const v = this.getValor({...e}, columnaName); return v !== undefined && v !== null ? v.toString() : ""; }, form: (e) => this.getValor({...e}, columnaName) };
          }
          return { ...base,
            valor: (e) => { const val = e[columnaName]; if (val === null || val === undefined) return ""; if (typeof val === "object") { const r = this.renderColumnaObject(e, columnaName); return typeof r === "string" ? r : ""; } return val.toString(); },
            form: (e) => { const val = e[columnaName]; if (val === null || val === undefined) return ""; if (typeof val === "object") return this.renderColumnaObject(e, columnaName); return val; }
          };
      }
    });
    cols.push({
      columna: "_llamar",
      label: "Llamar",
      valor: (e) => { 
        const mPatioTemp = this.props.movPatio && this.props.movPatio[e.id];
        const numero = mPatioTemp ? mPatioTemp.operadorContacto : null;
        const operador = mPatioTemp ? mPatioTemp.operadorNombre : "";
        return (operador ? operador + ": " : "") + numero
      },
      form: (e) => {
        const mPatioTemp = this.props.movPatio && this.props.movPatio[e.id];
        const numero = mPatioTemp ? mPatioTemp.operadorContacto : null;
        const operador = mPatioTemp ? mPatioTemp.operadorNombre : "";
        if (!Number(numero)) return "";
        return (
          <i
            className="fa fa-volume-control-phone text-primary btn"
            data-toggle="tooltip"
            data-placement="top"
            title={"Realizar llamada a " + (operador ? operador + " " : "") + numero}
            style={{ fontSize: "20px", cursor: "pointer" }}
            onClick={(ev) => {
              ev.stopPropagation();
              if(numero)
                publicarLlamadaWebphone(numero);
            }}
          />
        );
      },
    });
    cols.push({
      columna: "_ruteador",
      label: "Ruta",
      form: (e) => (
        <span
          onClick={(ev) => {
            ev.stopPropagation();
            const origenNombre = e.idCorredor ? e.idCorredor.nombre : '';
            const origenCoords = e.idCorredor && e.idCorredor.latitud && e.idCorredor.longitud ? [e.idCorredor.latitud, e.idCorredor.longitud] : null;
            this.setState({ ruteadorModal: { movId: e.id, origen: origenNombre, origenCoords, destino: e.destino || '', gpsIds: e.movimientoGps ? e.movimientoGps.map((g) => g.gps.idGg) : [] } });
          }}
          title="Ver ruta"
          style={{ color: '#2563eb', fontSize: '14px', cursor: 'pointer' }}
        >
          🗺️
        </span>
      ),
    });
    return cols;
  };

  render() {
    return (
      <Grid.Col lg={12}>
        <div className="m-3 collapse">
          { this.state.elementos.length > 0 && this.state.topics.length > 0 && (            
            <MonitoreoMensajeria
              topic={this.state.topics}
              mtipo={this.props.mtipo}
              gpsTipo={this.props.gpsTipo}
              mensaje={this.mensaje}
              elementosN={this.state.elementos}
              storeFunction={this.update_Store_Elements}
              update={this.updateStatus_elementos}
              openmodal={this.state.hiddenModals}
              metodo={this.state.metodo}
              stor={this.props}
              movPatio={this.props.movPatio}
              updateMovPatio={this.props.updateMovPatio}
            />
          )}
        </div>
        <i
          className={`${classes.icon} ${classes.static} ${
            this.state.Navigator ? "fa fa-angle-down" : "fa fa-angle-up"
          }`}
          style={{ cursor: "pointer" }}
          onClick={this.hideNav}
        />
        { [6,21].includes(user.id) ?
              <li
                className="badge"
                onClick={() => window.open(
                  "https://app.powerbi.com/view?r=eyJrIjoiN2E2OTMxYjctZjk1OC00MTQyLWIyYjAtMDU4ODAxNjdlM2U5IiwidCI6ImFiM2FmMjJkLWI4ZjEtNGE1Yy05M2NhLWNiMDVkZGE0OGFjZCJ9",
                  "sharer",
                  "width=900,height=600,scrollbars=NO"
                )
              }
                data-toggle="tooltip"
                data-placement="top"
                title={"Powerbi Navieros"}
              >
                <img src="images/powerbi.png" width="30px" />
              </li>
          : null}
        <span
          className="badge"
          style={{ cursor: "pointer", fontSize: "14px", color: this.state.autoRefreshActive ? "green" : "gray" }}
          onClick={() => {
            if (this.state.autoRefreshActive) {
              this.detenerAutoRefresh();
              this.setState({ autoRefreshActive: false });
            } else {
              this.setState({ autoRefreshActive: true }, () => this.iniciarAutoRefresh());
            }
          }}
          data-toggle="tooltip"
          data-placement="top"
          title={this.state.autoRefreshActive ? "AutoRefresh activo (click para desactivar)" : "AutoRefresh inactivo (click para activar)"}
        >
          <i className={this.state.autoRefreshing ? "fa fa-refresh fa-spin" : (this.state.autoRefreshActive ? "fa fa-refresh" : "fa fa-refresh")} />
          {this.state.autoRefreshing && <span style={{ marginLeft: "5px", fontSize: "11px" }}>Actualizando...</span>}
          {!this.state.autoRefreshing && this.state.lastRefreshTime && (
            <span style={{ marginLeft: "5px", fontSize: "11px", color: "#888" }}>
              Últ: {this.state.lastRefreshTime.toLocaleTimeString("es-MX", { hour: "2-digit", minute: "2-digit", second: "2-digit" })}
            </span>
          )}
        </span>
        <Card>
          <Card.Body>
            {this.state.loadingProgress < 100 && (
              <div style={{ width: '100%', backgroundColor: '#e0e0e0', position: 'relative', height: '12px', borderRadius: '4px' }}>
                <div style={{ width: this.state.loadingProgress + '%', height: '100%', backgroundColor: '#467fcf', transition: 'width 0.3s ease', borderRadius: '4px' }} />
                <span style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', fontSize: '9px', lineHeight: '10px', color: '#333' }}>{this.state.loadingProgress}%</span>
              </div>
            )}
              {this.state.columnasPageable && this.state.columnasPageable.length ? (
                <div style={{ color: "black", fontSize: "80%" }}>
                <TablePageable
                  titulo={  !this.state.Navigator && (
                            <div
                              className={`form-row align-items-center ${classes.jumb}`}
                              style={{ marginRight: "0px", marginLeft: "0px" }}
                            >
                            
                              {this.estaPrivilegioActivo("CargaMasiva") &&
                                this.getFuncionalidadGeneral("Importar") &&
                                this.state.excelRender && (
                                  <div class="col-auto">
                                    <ImportarN crud={this.getfuntion} catalogo={this.catalogo} />
                                  </div>
                                )}
                              {this.estaPrivilegioActivo("CargaMasiva") &&
                                this.getFuncionalidadGeneral("Importar") &&
                                this.state.excelRender && (
                                  <div class="col-auto">
                                    <ImportarNJson crud={this.getfuntion} catalogo={this.catalogo} />
                                  </div>
                                )}
                              
                              {this.getFuncionalidadGeneral("Importar") &&
                                this.state.excelRender && (
                                  <div class="col-auto">
                                    <Plantilla crud={this.getfuntion} catalogo={this.catalogo} />
                                  </div>
                                )}
                              {false && this.getFuncionalidadGeneral("Exportar") &&
                                this.state.excelRender && (
                                  <div class="col-auto">
                                    <Exportar
                                      crud={this.getfuntion}
                                      catalogo={this.catalogo}
                                      data={this.state.movActToExpor}
                                    />
                                  </div>
                                )}
                              {false && this.getFuncionalidadGeneral("Importar") &&
                                this.state.excelRender && (
                                  <a>
                                    {this.catalogo === "navieraMovimientos" && (
                                      <div class="col-auto">
                                        <Manual crud={this.getfuntion} catalogo={this.catalogo} />
                                      </div>
                                    )}
                                  </a>
                                )}
                              {this.getFuncionalidadGeneral("Movimientos Completos") && (
                                <li
                                  className="nav-item active "
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Movimientos terminados"
                                >
                                  <a>
                                    <ModalLay
                                      tamanio={"85%"}
                                      title="Terminados"
                                      name={
                                        <i className="fa fa-file-text-o" style={{fontSize: "24px"}}></i>
                                      }
                                      formulario={IncompletosTerminados}
                                      datosForm={{
                                        mtipo: this.props.mtipo,
                                        columnas: this.props.columnas,
                                        elementos: this.state.elementos,
                                        closeModal: this.hiddenmodal,
                                        plataformaTipo: "Naviera",
                                        stor: this.props,
                                        incompletos: false,
                                      }}
                                    />
                                  </a>
                                </li>
                              )}
                              {this.getFuncionalidadGeneral("Movimientos Incompletos") && (
                                <li
                                  className="nav-item active"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Movimientos terminados con datos incompletos"
                                >
                                  <a>
                                    <ModalLay
                                      tamanio={"85%"}
                                      title="Terminados con datos incompletos"
                                      name={
                                        <i className="fa fa-file-text" style={{fontSize: "24px"}}></i>
                                      }
                                      formulario={IncompletosTerminados}
                                      datosForm={{
                                        mtipo: this.props.mtipo,
                                        columnas: this.props.columnas,
                                        elementos: this.state.elementos,
                                        closeModal: this.hiddenmodal,
                                        plataformaTipo: "Naviera",
                                        stor: this.props,
                                        incompletos: true,
                                      }}
                                    />
                                  </a>
                                </li>
                              )}
                              {this.estaPrivilegioActivo("movimientos_agregar") &&
                                this.getFuncionalidadGeneral("Agregar Movimiento") && (
                                  <li className="nav-item active">
                                    <a>
                                      <ModalLay
                                        resumirModal={this.props.resumeModal}
                                        funcionReanudar={this.props.functionReanudarModal}
                                        title="Nuevo"
                                        name={
                                          <i
                                            className="fa fa-plus-square"
                                            style={{fontSize: "24px"}}
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Nuevo movimiento"
                                          ></i>
                                        }
                                        tamanio={this.tamanio}
                                        formulario={this.Catalogo_form}
                                        datosForm={{
                                          accion: "nuevo",
                                          getfuntion: this.getfuntion,
                                          stor: this.props,
                                          Fclose: this.hiddenmodal,
                                          refreshMovimiento: this.refreshMovimientoById,
                                        }}
                                      />
                                    </a>
                                  </li>
                                )}
                            </div>
                          )}
                  lista={this.getListaFiltrada()}
                  columnas={this.state.columnasPageable}
                  id="id"
                  selected={this.handleSelectMovimiento}
                  paginacion={true}
                  paginacionArriba={true}
                  elementosPorPagina={50}
                  buscar={this.state.buscar}
                  buscarTs={this.state.buscarTs}
                  resaltarFuncion={(e) => {
                    //if (this.state.selectedRow === e.id) return true;
                    /*
                    if ([61,1711].includes(e.idPlataforma.id)) {
                      for (let h of ['citaProgramadaTerminal', 'citaProgramada','horaMaximaSalida']) {
                        const resp = validarHorarios(e, h);
                        if (resp.vencida) return true;
                      }
                    }
                    if (e.reaccion) return true;*/
                    return true;
                  }}
                  resaltarColor={(e) => {
                    //if (this.state.selectedRow === e.id) return "rgba(95, 231, 50, 0.30)";
                    
                    if ([61,1711].includes(e.idPlataforma.id)) {
                      for (let h of ['citaProgramadaTerminal', 'citaProgramada','horaMaximaSalida']) {
                        const resp = validarHorarios(e, h);
                        if (resp.vencida) return resp.fondo;
                      }
                    }
                    try {
                      var tieneGPS;
                      this.state.gpsN[e.id] ? (tieneGPS = true) : (tieneGPS = false);
                    } catch (ex) { tieneGPS = false; }
                    try {
                      if (!tieneGPS) { e.movimientoGps.length ? (tieneGPS = true) : (tieneGPS = false); }
                      if (!tieneGPS) { this.props.movPatio[e.id].esFull ? (tieneGPS = true) : (tieneGPS = false); }
                    } catch (ex) {}
                    var json = JSON.stringify(e.movimientoGps);
                    if (json.search('"nombre":"PENDIENTE"') > 0) {
                      e.movimientoGps.length >= 2 ? (tieneGPS = true) : (tieneGPS = false);
                    }
                    var dt = new Date(e.citaProgramada);
                    if (dt.getTime()) {
                      if (dt < Date.now()) {
                        if (!tieneGPS) return "rgba(255, 20, 20, 0.35)";
                        try {
                          if (e.arriboTerminalVacio == null && e.arriboClienteLleno == null && e.arriboDirecionCarga == null && e.arriboClienteVacio == null && e.arriboTerminalCargado == null) {
                            return "rgba(100, 233, 231, 0.20)";
                          }
                        } catch (ex) {}
                      }
                      if (!tieneGPS) {
                        var dt2 = new Date(e.citaProgramada);
                        if (dt2.setHours(dt2.getHours() - 3) > Date.now() && new Date(e.citaProgramada).setHours(new Date(e.citaProgramada).getHours() - 6) < Date.now()) {
                          return "rgba(255, 20, 20, 0.15)";
                        }
                        var dt3 = new Date(e.citaProgramada);
                        if (dt3.setHours(dt3.getHours() - 3) < Date.now()) {
                          return "rgba(255, 20, 20, 0.25)";
                        }
                        if (e.probabilidadReaccion) return "rgba(244, 77, 0, 0.95)";
                      }
                    }
                    if (e.reaccion) return "rgba(255, 20, 20, 0.80)";
                    return null;
                  }}
                  csvname={"Movimientos"}
                />
                </div>
              ) : null}
          </Card.Body>
        </Card>
        <div hidden={!this.state.showErrormessage}>
          {this.state.ErrorMessage}
        </div>
        {this.state.ruteadorModal && (
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)' }} onClick={() => this.setState({ ruteadorModal: null })} />
            <div style={{ position: 'relative', width: '90vw', height: '80vh', background: '#fff', borderRadius: 8, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.3)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 16px', borderBottom: '1px solid #eee' }}>
                <b>Ruteador</b>
                <button onClick={() => this.setState({ ruteadorModal: null })} style={{ border: 'none', background: 'none', fontSize: 20, cursor: 'pointer' }}>✕</button>
              </div>
              <div style={{ height: 'calc(100% - 45px)' }}>
                <RuteadorContent
                  initialOrigen={this.state.ruteadorModal.origen}
                  initialOrigenCoords={this.state.ruteadorModal.origenCoords}
                  initialDestino={this.state.ruteadorModal.destino}
                  gpsIds={this.state.ruteadorModal.gpsIds}
                  movId={this.state.ruteadorModal.movId}
                  height="100%"
                />
              </div>
            </div>
          </div>
        )}
      </Grid.Col>
    );
  }
}
function mapStateToProps(state) {
  return {
    movimientos_naviera_object:
      state.catalogos_reducer.movimientos_naviera_object,
    //movimientos_terrestres_object: state.catalogos_reducer.movimientos_terrestres_object,
    movimientosTipo_object: state.catalogos_reducer.movimientosTipo_object,
    clientes_object: state.catalogos_reducer.clientes_object,
    navieras_object: state.catalogos_reducer.navieras_object,
    localidades_object: state.catalogos_reducer.localidades_object,
    operacionesEstatus_object:
      state.catalogos_reducer.operacionesEstatus_object,
    incidencias_object: state.catalogos_reducer.incidencias_object,
    operacionesTipo_object: state.catalogos_reducer.operacionesTipo_object,
    otd_object: state.catalogos_reducer.otd_object,
    plataformas_object: state.catalogos_reducer.plataformas_object,
    rutasEstatus_object: state.catalogos_reducer.rutasEstatus_object,
    transportistas_object: state.catalogos_reducer.transportistas_object,
    corredores_object: state.catalogos_reducer.corredores_object,
    funcionalidades_object: state.catalogos_reducer.funcionalidades_object,
    privilegios_object: state.catalogos_reducer.privilegios_object,
    operadores_object: state.catalogos_reducer.operadores_object,
    updateStatusMensaje_Object: state.catalogos_reducer.update_mensaje,
    etiquetas_object: state.catalogos_reducer.etiquetas_object,
  };
}
function mapDispachToProps(dispach) {
  return {
    incidencias_update: (elementos) =>
      dispach(ACTIONS.elementos_incidencias_imput(elementos)),
    movimientos_naviera_update: (elementos) =>
      dispach(ACTIONS.elementos_movimientos_naviera_imput(elementos)),
    updateStatusMensaje: (status) => dispach(ACTIONS.update_mensaje(status)),
    movimientosTipo_update: (elementos) =>
      dispach(ACTIONS.elementos_movimientosTipo_imput(elementos)),
    clientes_update: (elementos) =>
      dispach(ACTIONS.elementos_clientes_imput(elementos)),
    navieras_update: (elementos) =>
      dispach(ACTIONS.elementos_navieras_imput(elementos)),
    localidades_update: (elementos) =>
      dispach(ACTIONS.elementos_localidades_imput(elementos)),
    operacionesEstatus_update: (elementos) =>
      dispach(ACTIONS.elementos_operacionesEstatus_imput(elementos)),
    operacionesTipo_update: (elementos) =>
      dispach(ACTIONS.elementos_operacionestipo_imput(elementos)),
    otd_update: (elementos) => dispach(ACTIONS.elementos_otd_imput(elementos)),
    plataformas_update: (elementos) =>
      dispach(ACTIONS.elementos_plataformas_imput(elementos)),
    rutasEstatus_update: (elementos) =>
      dispach(ACTIONS.elementos_rutasEstatus_imput(elementos)),
    transportistas_update: (elementos) =>
      dispach(ACTIONS.elementos_transportistas_imput(elementos)),
    corredores_update: (elementos) =>
      dispach(ACTIONS.elementos_corredores_imput(elementos)),
    funcionalidades_update: (elementos) =>
      dispach(ACTIONS.elementos_funcionalidades_imput(elementos)),
    privilegios_update: (elementos) =>
      dispach(ACTIONS.elementos_privilegios_imput(elementos)),
    operadores_update: (elementos) =>
      dispach(ACTIONS.elementos_operadores_imput(elementos)),
    etiquetas_update: (elementos) =>
      dispach(ACTIONS.elementos_etiquetas_imput(elementos)),
  };
}
export default connect(mapStateToProps, mapDispachToProps, null, { forwardRef: true })(Catalogo);